import type { ReactNode } from "react";
import type { SheetSnap } from "../../shared/types";

interface BottomSheetProps {
  title: string;
  snap: SheetSnap;
  onClose: () => void;
  onSnapChange?: (nextSnap: SheetSnap) => void;
  children: ReactNode;
  modal?: boolean;
}

export function BottomSheet({
  title,
  snap,
  onClose,
  onSnapChange,
  children,
  modal = false,
}: BottomSheetProps) {
  const hidden = snap === "hidden";

  return (
    <>
      {modal && !hidden ? (
        <button
          aria-label={`Close ${title}`}
          className="sheet-backdrop"
          onClick={onClose}
          type="button"
        />
      ) : null}
      <section
        aria-hidden={hidden}
        className={`bottom-sheet bottom-sheet--${snap}`}
      >
        <div className="bottom-sheet__handle-row">
          <button
            aria-label={`Toggle ${title} height`}
            className="bottom-sheet__handle"
            onClick={() => {
              if (!onSnapChange) {
                return;
              }

              if (snap === "half") {
                onSnapChange("full");
                return;
              }

              if (snap === "full") {
                onSnapChange("half");
              }
            }}
            type="button"
          />
        </div>
        <header className="bottom-sheet__header">
          <div>
            <p className="eyebrow">Mobile panel</p>
            <h2>{title}</h2>
          </div>
          <div className="bottom-sheet__actions">
            {onSnapChange && snap !== "hidden" ? (
              <>
                <button
                  className="ghost-button"
                  onClick={() => onSnapChange("half")}
                  type="button"
                >
                  Half
                </button>
                <button
                  className="ghost-button"
                  onClick={() => onSnapChange("full")}
                  type="button"
                >
                  Full
                </button>
              </>
            ) : null}
            <button className="ghost-button" onClick={onClose} type="button">
              Close
            </button>
          </div>
        </header>
        <div className="bottom-sheet__content">{children}</div>
      </section>
    </>
  );
}
